<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import QrReader from '@/vcs/_shared/QrReader.vue'
import { XIcon } from 'vue-feather-icons'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  components: { QrReader, XIcon },
  extends: BaseModal,
  computed: {
    headerStyle() {
      return this.$isRemoteClient && this.$route.path != '/qr' ? { top: '7rem' } : {}
    }
  },
  methods: {
    onDecode(event) {
      console.log('onDecode', event)
      eventBus.$emit('pass-qr-reader-event-to-pickup', event)
      eventBus.$emit('pass-qr-reader-event-to-delivery', event)
      eventBus.$emit('decode-auth-qr', event)
      // INFO: for some reason we used closeAllModals()
      // close(event)
      this.closeAllModals()
    },
    closeAllModals() {
      this.$store.commit('modal/closeAllModals')
    }
  }
}
</script>

<template lang="pug">
span
  .modal-fixed-text-top(:style="headerStyle")
    h3 {{ $t('scanQrCode') }}
    .modal-fixed-controls(@click="closeAllModals()")
      x-icon(size="1.5x")
  .modal-body.p-0.h-100
    qr-reader(@onDecode="onDecode($event)")
  .modal-fixed-text-bottom
    h3 {{ $t('scanQrCode') }}
</template>

<style lang="scss" scoped>
@import '@/assets/styles/mixins.scss';
.modal-body {
  background: black;
}
</style>
